import { render } from "./CustomerStories.vue?vue&type=template&id=a8ccc05c&scoped=true"
import script from "./CustomerStories.vue?vue&type=script&lang=js"
export * from "./CustomerStories.vue?vue&type=script&lang=js"

import "./CustomerStories.vue?vue&type=style&index=0&id=a8ccc05c&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8ccc05c"]])

export default __exports__